import type { FinanceReportSortBy } from './useGetFinanceReport'
import type { SortInput } from 'components/Table'

export const DEFAULT_SORT: SortInput<FinanceReportSortBy> = {
  by: 'period',
  direction: 'desc',
} as const

export const SORTABLE_COLUMNS: FinanceReportSortBy[] = ['period']
